module.exports = __webpack_public_path__ + "img/plSuc.5380fd9d.svg";